import validate from 'validate.js';
import {parsePhoneNumberFromString as parseMobile} from "libphonenumber-js/max";

const constraints = {
    from: {email: true},
    phone: {numericality: true}
};

export function validateEmail(from: string) {
    return !validate({from}, constraints);
}

export function validatePhone(countryCode: string, phone: string) {
    if (validate({phone}, constraints))
        return false;
    const phoneNumber = parseMobile(`${countryCode}${phone}`);
    return !!phoneNumber && phoneNumber.isValid();
}
